import { Card } from "antd";
import LeftArrow from "Assets/Icons/LeftArrow";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import Typography from "Components/CommonComponents/Typography";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";
import styled from "styled-components";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
import { useNavigate } from "react-router-dom";
const StyledCard = styled<any>(Card)`
  border-radius: 8px;
  .ant-card-bordered {
    border: 0px !important;
  }
  .ant-card-body {
    padding: ${(props: any) =>
      !["xs", "sm", "md"].includes(props.screen) ? "0px" : "0px"};
    border: 0px !important;
    margin-top: ${(props: any) =>
      ["xs", "sm", "md"].includes(props.screen) ? "0px" : "0px"};
  }
  .ant-card-bordered {
    border: 0px !important;
  }
  .ant-tabs-nav-wrap {
    background: white;
  }
`;
const QuizDetailsHeader = ({ scheduledata }: any) => {
  const { screen }: any = useWindowSize();
  const navigate = useNavigate();
  const { isCreateMode, resetStates } = useQuizContext();
  const { eventName, batchName, eventType, startTime, endTime } = scheduledata;
  const eventNameForHeader = eventType === "Lecture" ? eventName : eventType;
  const handleBacknavigation = () => {
    if (isCreateMode) {
      resetStates();
      return;
    }
    navigate("/admin/dashboard");
  };
  return (
    <StyledCard
      screen={screen}
      className="d-flex mt-3 mb-3 attendance-header-main-conteniner"
    >
      <div className="d-flex flex-row align-items-center">
        <LeftArrow
          className={"cursorHoverCSS mr-3 ml-1"}
          onClick={() => {
            handleBacknavigation();
          }}
        />

        <div
          className={
            ["xxl", "xl", "lg"].includes(screen)
              ? "d-flex flex-row gap-2"
              : "d-flex flex-column"
          }
        >
          <div>
            <Typography
              variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
              color="darkgray"
            >
              {eventNameForHeader} {batchName ? "| " + batchName : ""}
            </Typography>
          </div>
          <div className="d-flex flex-row align-items-center">
            <Typography
              variant={
                ["xxl", "xl", "lg"].includes(screen)
                  ? "subheading3"
                  : "forminfo"
              }
              color="gray"
            >
              <span> {convertTime(startTime, "D MMM, ddd")} |&nbsp;</span>
              <span className="pr-2">{convertTime(startTime, "h:mm")} -</span>
              <span>{convertTime(endTime, "h:mm a")}</span>
            </Typography>
          </div>
        </div>
      </div>
    </StyledCard>
  );
};

export default QuizDetailsHeader;
